import React, { useMemo } from "react";
import styled from "styled-components";
import { IShipmentKpis, ShipmentFeedback } from "../../types/shipment";
import { Tooltip } from "antd";
import NpiDisplayDate from "../display/date";
import {useTranslation} from "react-i18next";

const StyledCategory = styled.span`
    margin-bottom: 0px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
`;
const StyledValue = styled.span` 
    color: rgba(0, 0, 0, 0.85);
`;


export interface IShipmentKpisProps {
    kpis: IShipmentKpis;
    status : ShipmentFeedback;
}
const ShipmentsKpis = (props: IShipmentKpisProps): JSX.Element => {

    const { kpis, status } = props;
    const { t } = useTranslation();

    const percent = useMemo(() => {
        const received = status === ShipmentFeedback.POS ? kpis.total_received_pos : kpis.total_received_vendor;
        return ((received / kpis.total_assets) * 100 || 0).toFixed(1);
    }, [kpis, status]);

    return (
        <div style={{height: '100%'}}>
            <div>
                <Tooltip placement="right" title="Total of lines in DB."><span>
                    <StyledCategory><span>{t('INTERNAL.CLIENT.SHIPMENT.SHIPMENT_STATS.TOTAL_IMPORTED')}: </span></StyledCategory> &nbsp; <StyledValue>{ kpis.total_lines }</StyledValue>
                </span></Tooltip>
            </div>
            <div>
                <Tooltip placement="right" title="Total of lines from file."><span>
                    <StyledCategory><span>{t('INTERNAL.CLIENT.SHIPMENT.SHIPMENT_STATS.TOTAL_WITHOUT_MERGE')}: </span></StyledCategory> &nbsp; <StyledValue>{ kpis.total_lines_merged }</StyledValue>
                </span></Tooltip>
            </div>
            <div>
                <Tooltip placement="right" title="Total number of unique Tracking IDs"><span>
                    <StyledCategory><span>{t('INTERNAL.CLIENT.SHIPMENT.SHIPMENT_STATS.TOTAL_PACKAGE')}: </span></StyledCategory> &nbsp; <StyledValue>{ kpis.total_packages }</StyledValue>
                </span></Tooltip>
            </div>
            <div>
                <Tooltip placement="right" title="Sum of all Material Quantity"><span>
                    <StyledCategory><span>{t('INTERNAL.CLIENT.SHIPMENT.SHIPMENT_STATS.TOTAL_ASSETS')} : </span></StyledCategory> &nbsp; <StyledValue>{ kpis.total_assets }</StyledValue>
                </span></Tooltip>
            </div>
            <div>
                <Tooltip placement="right" title={`percentage of asset quantities  ${status === ShipmentFeedback.VENDOR ? 'delivered' : 'received'}` }><span>
                    <StyledCategory><span>{status === ShipmentFeedback.VENDOR ? t('INTERNAL.CLIENT.SHIPMENT.SHIPMENT_STATS.TOTAL_DELIVRED')+ ' :' : t('INTERNAL.CLIENT.SHIPMENT.SHIPMENT_STATS.TOTAL_RECEIVED') + ' :'}</span></StyledCategory> &nbsp; <StyledValue>{`${percent}%`}</StyledValue>
                </span></Tooltip>
            </div>
            <div>
                <Tooltip placement="right" title="Total number of all assets with awaiting dispatch status"><span>
                    <StyledCategory><span>{t('INTERNAL.CLIENT.SHIPMENT.SHIPMENT_STATS.TOTAL_AWAITNG')}: </span></StyledCategory> &nbsp; <StyledValue>{ kpis.total_awaiting_dispatch }</StyledValue>
                </span></Tooltip>
            </div>
            <div>
                <Tooltip placement="right" title="When data was last updated"><span>
                    <StyledCategory><span>{t('INTERNAL.CLIENT.COMMON.LAST_UPDATED_AT')}: </span></StyledCategory> &nbsp; <StyledValue><NpiDisplayDate value={kpis.update_date} hours={'inline'}/></StyledValue>
                </span></Tooltip>
            </div>
        </div>
    );
};

export default ShipmentsKpis;